/**
 * ============================================================
 * SearchBar.js — Reusable Text Search Input
 * ============================================================
 *
 * A small utility component used across Admin pages to provide
 * a consistent search bar UI. Designed for lightweight filtering
 * of lists (people, projects, publications, admin users, etc.).
 *
 * Props:
 *   - placeholder  (string)  — placeholder text
 *   - label        (string)  — optional label displayed above input
 *   - onChange     (func)    — callback fired on input change
 *   - className    (string)  — optional extra CSS classes
 *
 * Notes:
 *   - Uses React-Bootstrap <Form.Control> for styling consistency.
 *   - Does NOT manage internal state; parent components control value.
 **/

import React from "react";
import Form from "react-bootstrap/Form";

import "./css/AdminComponents.css";


// ------------------------------------------------------------
// Component
// ------------------------------------------------------------
const SearchBar = (props) => {
  const { onChange, placeholder, label, className } = props;

  // ------------------------------------------------------------
  // Render
  // ------------------------------------------------------------
  return (
    <div className="admin-searchbar-container">
      {label && <Form.Label>{label}</Form.Label>}

      <Form.Control
        type="text"
        placeholder={placeholder}
        onChange={onChange}
        className={className}
      />
    </div>
  );
};

export default SearchBar;